type PendingRequest<T> = Promise<T>;

const pendingRequests = new Map<string, PendingRequest<any>>();

export function deduplicateRequest<T>(key: string, request: () => Promise<T>): Promise<T> {
  if (pendingRequests.has(key)) {
    return pendingRequests.get(key)!;
  }

  const promise = request().finally(() => {
    pendingRequests.delete(key);
  });

  pendingRequests.set(key, promise);
  return promise;
}

export function clearPendingRequests(): void {
  pendingRequests.clear();
}

export function getPendingRequestCount(): number {
  return pendingRequests.size;
}
